import { HttpParams } from "@angular/common/http";

export function getHttpParamsFromObj(query) {
    let params: HttpParams = new HttpParams();
    for (const key of Object.keys(query)) {
        if (query[key] !== undefined && query[key] !== null && query[key] !== "") {
            if (query[key] instanceof Array) {
                if (query[key].length) {
                    query[key].forEach((item) => {
                        params = params.append(`${key.toString()}[]`, item);
                    });
                }
            } else {
                params = params.append(key.toString(), query[key]);
            }
        }
    }
    return params;
}

export function trackByUuid(index: number, item: any): any {
    return item.uuid || index;
}

export function getPropertyOfObject(obj, prop) {

    if(typeof obj === 'undefined') {
        return undefined;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return getPropertyOfObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
}

export function toInstance<T>(obj: T, json: string) : T {
    var jsonObj = JSON.parse(json);

    if (typeof obj["fromJSON"] === "function") {
        obj["fromJSON"](jsonObj);
    }
    else {
        for (var propName in jsonObj) {
            obj[propName] = jsonObj[propName]
        }
    }

    return obj;
}
